<template>
  <div>
    <Form :validation-schema="schema" @submit="handleRegister">

      <div class="candidature-body"/>
      <CandidatureHeader></CandidatureHeader>
      <CandidatureSteps :level=1></CandidatureSteps>
      <div v-if="status == ''" class="candidature-alert"><b>Attention :</b> votre dossier de candidature sera enregistré seulement à l'étape 3.</div>
      <div class="candidature-info">* champs obligatoires</div>

      <div class="candidature-group">
        <h1><img src="@/assets/img/underline.png"> NIVEAU D'ÉTUDES </h1>

        <div class="candidature-group-sub">
          <div id="faculty-anchor" class="candidature-condition candidature-condition-col row">
            <label class="candidature-condition-text" for="nameField">Filière du dernier diplôme obtenu *</label>
            <Field v-model="diplomaFaculty" class="form-control" name="diplomaFaculty" placeholder="" type="text"/>
            <ErrorMessage class="error-feedback" name="diplomaFaculty"/>
          </div>

          <div id="diploma-anchor" class="candidature-condition candidature-condition-col row">
            <label class="candidature-condition-text" for="nameField">Niveau du diplôme *</label>
            <Field v-model="diplomaLevel" as="select" class="form-control" name="diplomaLevel">
              <option disabled value=""></option>
              <option value="928687">Mention complémentaire</option>
              <option value="928679">Autre diplôme ou titre de niveau bac</option>
              <option value="928675">Baccalauréat technologique</option>
              <option value="928674">Baccalauréat général</option>
              <option value="928673">Baccalauréat professionnel</option>
              <option value="928671">Autre diplôme ou titre de niveau bac +2</option>
              <option value="928669">Diplôme Universitaire de technologie</option>
              <option value="928667">Brevet de Technicien Supérieur</option>
              <option value="928666">Autre diplôme ou titre de niveau bac +3 ou 4</option>
              <option value="928665">Licence générale</option>
              <option value="928664">Licence professionnelle</option>
              <option value="928653">Master 1 professionnel</option>
              <option value="928652">Autre diplôme ou titre de niveau bac +5 ou plus</option>
              <option value="928651">Master 2 recherche / DEA</option>
              <option value="928650">Master 2 professionnel / DESS / diplôme grande école</option>
              <option value="928645">Doctorat</option>
            </Field>
            <ErrorMessage class="error-feedback" name="diplomaLevel"/>
          </div>

          <div id="diploma-year-anchor" class="candidature-condition candidature-condition-col row">
            <label class="candidature-condition-text" for="nameField">Année du diplôme*</label>
            <Field v-model="diplomaYear" as="select" class="form-control" name="diplomaYear">
              <option disabled value=""></option>
              <option v-for="year in years" v-bind:key="year" :value="year">{{ year }}</option>
            </Field>
            <ErrorMessage class="error-feedback" name="diplomaYear"/>
          </div>
        </div>


        <div class="candidature-group-sub">
          <div id="last-study-anchor" class="candidature-condition candidature-condition-col row">
            <label class="candidature-condition-text" for="nameField">Dernière année d'étude suivie*</label>
            <Field v-model="lastLevelClass" as="select" class="form-control" name="lastLevelClass">
              <option value=""></option>
              <option value="4148749">Terminale Bac technologique</option>
              <option value="132739">DESS</option>
              <option value="123803">Maîtrise 2ème année</option>
              <option value="123802">Maîtrise 1ère année</option>
              <option value="115102">DUT - 2ème année</option>
              <option value="110514">DU (Bac + 3)</option>
              <option value="110513">DAEU</option>
              <option value="110512">Terminale BP / BM / BTM</option>
              <option value="110511">Mastère</option>
              <option value="110510">Licence - 3ème année</option>
              <option value="110509">DEA</option>
              <option value="110508">DEUG - 2ème année</option>
              <option value="110506">DEUST - 2ème année</option>
              <option value="110505">DUT - 1ère année</option>
              <option value="110501">BTS / BTSA - 2ème année</option>
              <option value="110498">Terminale BTA</option>
              <option value="110496">Prépa - 1ère année</option>
              <option value="110495">Prépa - 2ème année</option>
              <option value="110494">DEUG - 1ère année</option>
              <option value="110493">Terminale Bac Professionel</option>
              <option value="110492">Licence - 2ème année</option>
              <option value="110490">Licence - 1ère année</option>
              <option value="110489">BTS / BTSA - 1ère année</option>
              <option value="110488">Terminale Bac général</option>

            </Field>
            <ErrorMessage class="error-feedback" name="lastLevelClass"/>
          </div>
        </div>

        <div class="candidature-group-sub">
          <div class="candidature-condition candidature-condition-col">
            <div class="candidature-condition-text">Avez-vous déjà effectué une formation en contrat d'apprentissage ?</div>
            <div class="custom-control custom-switch">
              <input id="switchApprenticeshipContract" v-model="switchApprenticeshipContract" class="custom-control-input" type="checkbox">
              <label class="custom-control-label" for="switchApprenticeshipContract"></label>
            </div>
          </div>

          <div v-if="ifApprenticeshipContract" class="candidature-condition candidature-condition-col row">
            <label class="candidature-condition-text" for="nameField">Numéro d'enregistrement du contrat</label>
            <Field v-model="numApprenticeshipContract" class="form-control" name="numApprenticeshipContract" placeholder="" type="text"/>
            <ErrorMessage class="error-feedback" name="numApprenticeshipContract"/>
          </div>
        </div>
      </div>

      <div class="candidature-group">
        <h1><img src="@/assets/img/underline.png"> INFORMATIONS PERSONNELLES </h1>
        <div class="candidature-group-sub">
          <div class="candidature-condition candidature-condition-col">
            <div class="candidature-condition-text">Êtes-vous sur la liste des sportifs de haut niveau ?</div>
            <div class="custom-control custom-switch">
              <input id="switchSportif" v-model="switchSportif" class="custom-control-input" type="checkbox">
              <label class="custom-control-label" for="switchSportif"></label>
            </div>
          </div>
        </div>

        <div class="candidature-group-sub">
          <div class="candidature-condition candidature-condition-col">
            <div class="candidature-condition-text">Avez-vous un permis de conduire ?</div>
            <div class="custom-control custom-switch">
              <input id="switchPermis" v-model="switchPermis" class="custom-control-input" type="checkbox">
              <label class="custom-control-label" for="switchPermis"></label>
            </div>
          </div>

          <div v-if="ifPermis">
            <div class="candidature-condition candidature-condition-text candidature-condition-col">Type de Permis :</div>
            <div class="candidature-condition candidature-condition-text candidature-condition-col">
              <div class="col-md-6">
                <input v-model="checkboxAuto" class="candidature-checkbox" name="checkboxAuto" type="checkbox">
                <label>Auto</label>
              </div>
              <div class="col-md-6">
                <input v-model="checkboxMoto" class="candidature-checkbox" name="checkboxMoto" type="checkbox">
                <label>Moto</label>
              </div>
            </div>

            <div class="candidature-condition candidature-condition-col row">
              <label class="candidature-condition-text" for="nameField">Année du Permis*</label>
              <Field v-model="yearDrivingLicense" as="select" class="form-control" name="yearDrivingLicense">
                <option disabled value=""></option>
                <option v-for="year in years" v-bind:key="year" :value="year">{{ year }}</option>
              </Field>
              <ErrorMessage class="error-feedback" name="yearDrivingLicense"/>
            </div>
          </div>
        </div>

        <div class="candidature-group-sub">
          <div class="candidature-condition candidature-condition-col">
            <div class="candidature-condition-text">Signaler une situation de handicap ?</div>
            <div class="custom-control custom-switch">
              <input id="switchHandicap" v-model="switchHandicap" class="custom-control-input" type="checkbox">
              <label class="custom-control-label" for="switchHandicap"></label>
            </div>
          </div>

          <div v-if="ifHandicap">
            <div class="candidature-condition candidature-condition-col">
              <div class="candidature-condition-text">Bénéficiez-vous de la reconnaissance travailleur handicapé ?</div>
              <div class="custom-control custom-switch">
                <input id="switchTravailleurHandicape" v-model="switchTravailleurHandicape" class="custom-control-input" type="checkbox">
                <label class="custom-control-label" for="switchTravailleurHandicape"></label>
              </div>
            </div>

            <div class="candidature-condition candidature-condition-col">
              <div class="candidature-condition-text">Bénéficiez-vous d'un accompagnement ?</div>
              <div class="custom-control custom-switch">
                <input id="switchAccompagneHandicape" v-model="switchAccompagneHandicape" class="custom-control-input" type="checkbox">
                <label class="custom-control-label" for="switchAccompagneHandicape"></label>
              </div>
            </div>

            <div v-if="ifAccompagneHandicape">
              <div class="candidature-condition candidature-condition-col row">
                <label class="candidature-condition-text" for="nameField">Organisme d'accompagnement</label>
                <Field v-model="supportOrganization" class="form-control" name="supportOrganization" placeholder="" type="text"/>
                <ErrorMessage class="error-feedback" name="supportOrganization"/>
              </div>

              <div class="candidature-condition candidature-condition-col row">
                <label class="candidature-condition-text" for="nameField">Nature de l'accompagnement</label>
                <Field v-model="supportType" class="form-control" name="supportType" placeholder="" type="text"/>
                <ErrorMessage class="error-feedback" name="supportType"/>
              </div>
            </div>

            <div class="candidature-condition candidature-condition-col row">
              <label class="candidature-condition-text" for="nameField">Signalez des besoins spécifiques :</label>
              <textarea
                  id="besoinSpe"
                  v-model="textarea"
                  class="form-control"
                  name="besoinSpe"
                  rows="4"
                  spellcheck="false"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="candidature-group">
        <h1><img src="@/assets/img/underline.png"> PIÈCES JUSTIFICATIVES </h1>

        <!-- Section Photo de profil avec cropper -->
        <div class="candidature-condition">
          <input
              id="photoIdentityInput"
              accept="image/jpeg, image/png"
              class="candidature-input-file"
              type="file"
              style="display: none;"
              @change="handlePhotoSelect"
          >
          <div class="candidature-button" @click="$refs.photoInput.click()">
            <div class="candidature-button-content">
              <div>
                <div v-if="photocheck" class="candidature-button-icon"><img src="@/assets/img/check.png"></div>
                <div v-else class="candidature-button-icon"><img src="@/assets/img/plus.png"></div>
              </div>
              <div class="candidature-button-content-label">
                Photo de profil professionnelle<br>
                <a id="photoIdentityImg" :href="photoIdentityUrl" target="_blank" @click.stop>{{ photoIdentityName }}</a>

              </div>
            </div>
          </div>
          <input ref="photoInput" accept="image/jpeg, image/png" class="candidature-input-file" type="file" style="display: none;" @change="handlePhotoSelect">
        </div>

        <!-- Modal de recadrage -->
        <div v-if="showCropperModal" class="modal-overlay" @click="closeCropper">
          <div class="modal-content" @click.stop>
            <div class="modal-header">
              <h3>Recadrer votre photo de profil</h3>
              <button @click="closeCropper" class="close-btn">×</button>
            </div>
            <div class="modal-body">
              <vue-cropper
                  ref="cropper"
                  :src="imageSrc"
                  :aspect-ratio="1"
                  :view-mode="2"
                  :auto-crop-area="1"
                  :background="false"
                  :guides="true"
                  :center="true"
                  :highlight="true"
                  :crop-box-movable="true"
                  :crop-box-resizable="true"
                  :toggle-drag-mode-on-dblclick="true"
                  :rotatable="true"
                  :zoomable="false"
                  :img-style="{ 'max-width': '400px', 'max-height': '400px' }"
                  :initial-aspect-ratio="1"
                  :fit="true"
              />

            </div>
            <div class="modal-footer">

              <div class="rotation-controls">
                <button class="btn btn-icon btn-secondary" title="Pivoter à gauche" @click.prevent="rotateLeft">
                  <svg class="rotation-icon rotate-left" viewBox="0 0 24 24">
                    <path d="M7.11 8.53L5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47zM6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47zm1.01 5.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03L7.1 18.32zM13 4.07V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93z"/>
                  </svg>
                </button>
                <button class="btn btn-icon btn-secondary" title="Pivoter à droite" @click.prevent="rotateRight">
                  <svg class="rotation-icon" viewBox="0 0 24 24">
                    <path d="M15.55 5.55L11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45zM19.93 11c-.17-1.39-.72-2.73-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03zm3.89-2.42l1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48z"/>
                  </svg>
                </button>
              </div>
              <div class="action-controls">
                <button class="btn btn-secondary" @click="closeCropper">Annuler</button>
                <button class="btn btn-primary" @click.prevent="cropImage">Valider</button>
              </div>
            </div>
          </div>
        </div>


        <Field id="photocheck" ref="photocheck" v-model="photocheck" class="form-control" name="photocheck" placeholder="" style="visibility:hidden; height:0;" type="text"/>
        <ErrorMessage class="error-feedback" name="photocheck"/>

        <label class="candidature-condition" for="diplomaPdf">
          <input id="diplomaPdf" :name="diplomaPdf" accept="application/msword, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/jpeg, image/png" class="candidature-input-file" type="file" @change="filesChange($event.target.name, $event.target.files , 'diplomaA'); fileCount = $event.target.files.length">
          <div class="candidature-button">
            <div class="candidature-button-content">
              <div>
                <div v-if="diplomacheck" class="candidature-button-icon"><img src="@/assets/img/check.png"></div>
                <div v-else class="candidature-button-icon"><img src="@/assets/img/plus.png"></div>
              </div>
              <div class="candidature-button-content-label">Diplôme le plus élevé (minimum baccalauréat)<br><a id="diplomaA" :href="diplomaLink" target="_blank">{{ diplomaFileName }}</a></div>
            </div>
          </div>
        </label>
        <Field id="diplomacheck" ref="diplomacheck" v-model="diplomacheck" class="form-control" name="diplomacheck" placeholder="" style="visibility:hidden; height:0;" type="text"/>
        <ErrorMessage class="error-feedback" name="diplomacheck"/>
      </div>

      <div class="form-group">
        <button class="btn btn-primary btn-block" @click="handleClickValidation">
                <span
                    v-show="loading"
                    class="spinner-border spinner-border-sm"
                ></span>
          Étape suivante
        </button>
      </div>

    </Form>

  </div>
</template>

<script>
import {ErrorMessage, Field, Form} from "vee-validate";
import * as yup from "yup";
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import CandidatureHeader from '@/components/Candidature/Header.vue';
import CandidatureSteps from '@/components/Candidature/Steps.vue';
import UserService from "@/services/user.service";
import {simulateNewfiles} from "@/services/fake-href.service";

const API_URL = process.env.VUE_APP_API_URL;

export default {
  name: "CanditatureInfoPersonnelles",
  components: {
    Form,
    Field,
    ErrorMessage,
    VueCropper,
    CandidatureHeader,
    CandidatureSteps
  },
  data() {
    return {
      successful: false,
      loading: false,
      message: '',
      isSubmitted: false,
      textarea: '',
      candidacy: false,
      status: '',
      switchAccompagneHandicape: false,
      switchApprenticeshipContract: false,
      switchHandicap: false,
      switchPermis: false,
      switchSportif: false,
      switchTravailleurHandicape: false,
      supportOrganization: '',
      supportType: '',
      diplomaFaculty: '',
      diplomaLevel: '',
      diplomaYear: '',
      lastLevelClass: '',
      numApprenticeshipContract: '',
      checkboxAuto: false,
      checkboxMoto: false,
      yearDrivingLicense: '',
      photoIdentity: 'photoIdentity',
      diplomaPdf: 'diplomaPdf',
      diplomaMedia: '',
      FILE: null,
      FIELDNAME: null,
      ID: null,
      photoMedia: '',
      FILEPHOTO: null,
      FIELDNAMEPHOTO: null,
      IDPHOTO: null,
      photoIdentityUrl: '',
      photoIdentityName: '',
      photocheck: false,
      diplomaLink: '',
      diplomaFileName: '',
      diplomaMod: '',
      diplomacheck: false,
      showCropperModal: false,
      imageSrc: '',
      croppedImageFile: null,
    };
  },
  computed: {
    ifAccompagneHandicape() {
      return this.switchAccompagneHandicape;
    },
    ifApprenticeshipContract() {
      return this.switchApprenticeshipContract;
    },
    ifHandicap() {
      return this.switchHandicap;
    },
    ifPermis() {
      return this.switchPermis;
    },
    years() {
      const year = new Date().getFullYear();
      return Array.from({length: year - 1950}, (value, index) => year - index);
    },
    schema() {
      return yup.object().shape({
        diplomaFaculty: yup.string().required("Ce champ doit être renseigné"),
        diplomaLevel: yup.string().required("Ce champ doit être renseigné"),
        diplomaYear: yup.string().required("Ce champ doit être renseigné"),
        lastLevelClass: yup.string().required("Ce champ doit être renseigné"),
        supportOrganization: yup.string().nullable(true),
        supportType: yup.string().nullable(true),
        numApprenticeshipContract: yup.string()
            .matches(/^[0-9]{15}$|^$/, "Ce champ doit contenir exactement 15 chiffres ou rester vide")
            .nullable(true),
        diplomacheck: yup.string().matches("true", "Diplôme le plus élevé : Vous devez déposer un document"),
        photocheck: yup.string().matches("true", "Photo de profil : Vous devez déposer une photo")
      });
    },
  },
  mounted() {
    UserService.getCandidacyByUser().then((response) => {
      this.candidacy = response.data;
      this.status = response.data.status;
      this.switchSportif = response.data.is_athlete;
      this.switchPermis = response.data.if_car_license || response.data.if_moto_license;
      this.switchAccompagneHandicape = response.data.if_receives_support;
      this.checkboxAuto = response.data.if_car_license;
      this.checkboxMoto = response.data.if_moto_license;
      this.yearDrivingLicense = response.data.year_license;
      this.switchHandicap = response.data.is_handicap_person;
      this.switchTravailleurHandicape = response.data.is_handicap_worker;
      this.supportOrganization = response.data.support_organization;
      this.supportType = response.data.type_support;
      this.textarea = response.data.specific_needs_handicap;
      this.diplomaFaculty = response.data.last_diploma_course || '';
      this.diplomaLevel = response.data.last_diploma_level || '';
      this.diplomaYear = response.data.last_diploma_year || '';
      this.lastLevelClass = response.data.last_year_study || '';
      this.switchApprenticeshipContract = response.data.if_apprenticeship_contract;
      this.numApprenticeshipContract = response.data.num_apprenticeship_contract;
      let photoUrl = '';
      let photoName = '';
      let diplomaUrl = '';
      let diplomaName = '';
      if (response.data.medias.length > 0) {
        const mediaPhoto = response.data.medias.find(media => media.typeOfMedia === "PHOTOIDENTITY");
        photoUrl = mediaPhoto ? (mediaPhoto.toBeTransferred ? API_URL + mediaPhoto.filePath : mediaPhoto.fileLink) : '';
        photoName = mediaPhoto ? mediaPhoto.niceFileName : '';
        this.photocheck = photoUrl.length > 0;
        const mediaDiploma = response.data.medias.find(media => media.typeOfMedia === "DIPLOMA");
        diplomaUrl = mediaDiploma ? (mediaDiploma.toBeTransferred ? API_URL + mediaDiploma.filePath : mediaDiploma.fileLink) : '';
        diplomaName = mediaDiploma ? mediaDiploma.niceFileName : '';
        this.diplomacheck = diplomaUrl.length > 0;
      }
      this.photoIdentityUrl = photoUrl || null;
      this.photoIdentityName = photoName || null;
      this.diplomaLink = diplomaUrl || null;
      this.diplomaFileName = diplomaName || null;
    });
  },
  methods: {
    handleRegister(data) {
      this.message = "";
      this.successful = false;
      this.loading = true;
      this.register(data);
    },
    handleClickValidation() {
      this.isSubmitted = true;
    },
    register(data) {
      data.ifSportif = this.switchSportif;
      data.ifHandicap = this.switchHandicap;
      data.ifReceivesSupport = this.switchAccompagneHandicape;
      data.ifTravailleurHandicape = this.switchTravailleurHandicape;
      data.ifApprenticeshipContract = this.switchApprenticeshipContract;
      data.besoinSpe = this.textarea;
      data.ifCarLicense = this.checkboxAuto;
      data.ifMotoLicense = this.checkboxMoto;
      data.yearLicense = this.yearDrivingLicense;
      data.diplomaYear = data.diplomaYear.toString();
      if (this.croppedImageFile !== null) {
        const formDataPhoto = new FormData();
        formDataPhoto.append('file', this.croppedImageFile, this.croppedImageFile.name);
        data.photoMedia = formDataPhoto;
      } else if (this.FILEPHOTO !== null) {
        const formDataPhoto = new FormData();
        Array.from(this.FILEPHOTO).forEach(file => {
          formDataPhoto.append('file', file, file.name);
        });
        data.photoMedia = formDataPhoto;
      }
      if (this.FILE !== null) {
        const formData = new FormData();
        Array.from(this.FILE).forEach(file => {
          formData.append('file', file, file.name);
        });
        data.diplomaMedia = formData;
      }
      UserService.saveCandidacyPartOne(this.candidacy.id, data).then(() => {
        this.$router.push({name: 'ma-candidature-2'});
      });
    },
    handlePhotoSelect(event) {
      const file = event.target.files[0];
      if (!file) return;
      const allowedTypes = ['image/jpeg', 'image/png'];
      if (!allowedTypes.includes(file.type)) {
        alert('Le type de fichier n\'est pas autorisé. Utilisez JPEG ou PNG.');
        return;
      }
      if (file.size > (8 * 1000 * 1024)) {
        alert('Le fichier ne doit pas être supérieur à 8Mo');
        return;
      }
      this.FILEPHOTO = [file]; // Stocker le fichier original
      const reader = new FileReader();
      reader.onload = (e) => {
        this.imageSrc = e.target.result;
        this.showCropperModal = true;
      };
      reader.readAsDataURL(file);
    },
    cropImage() {
      if (!this.$refs.cropper) return;
      this.$refs.cropper.getCroppedCanvas({
        width: 300,
        height: 300,
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'high',
      }).toBlob((blob) => {
        const fileName = `photo_profile_${Date.now()}.jpg`;
        this.croppedImageFile = new File([blob], fileName, {type: 'image/jpeg'});
        this.photoIdentityName = fileName;
        this.photoIdentityUrl = URL.createObjectURL(blob);
        this.photocheck = true;
        simulateNewfiles(this.croppedImageFile, 'photoIdentityImg');
        this.closeCropper();
      }, 'image/jpeg', 0.9);
    },
    closeCropper() {
      this.showCropperModal = false;
      this.imageSrc = '';
      if (this.$refs.photoInput) {
        this.$refs.photoInput.value = '';
      }
    },
    rotateLeft() {
      if (this.$refs.cropper) {
        this.$refs.cropper.rotate(-90);
      }
    },
    rotateRight() {
      if (this.$refs.cropper) {
        this.$refs.cropper.rotate(90);
      }
    },
    filesChange(fieldName, fileList, id) {
      if (!fileList.length) return;
      const allowedTypes = document.getElementById(fieldName).accept.split(',').map(type => type.trim());
      if (!allowedTypes.includes(fileList[0].type)) {
        alert(`Le type de fichier n'est pas autorisé`);
        return;
      }
      if (fileList[0].size > (8 * 1000 * 1024)) {
        alert('Le fichier ne doit pas être supérieur à 8Mo');
        return;
      }
      this.FILE = fileList;
      this.FIELDNAME = fieldName;
      this.ID = id;
      simulateNewfiles(fileList[0], id);
      this.diplomacheck = true;
    },
    scrollAnchor(anchorId, value) {
      if (this.isSubmitted && value === '') {
        const anchorElement = document.getElementById(anchorId);
        if (anchorElement) {
          anchorElement.scrollIntoView({behavior: 'smooth'});
        }
        return false;
      }
    },
  },
};
</script>
<style>
.modal-overlay .cropper-point {
  width: 15px;
  height: 15px;
}
</style>
<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-overlay .modal-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow: auto;
}

.modal-overlay .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e5e5e5;
}

.modal-overlay .modal-header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #333;
}

.modal-overlay .close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.modal-overlay .close-btn:hover {
  background: #f5f5f5;
  color: #333;
}

.modal-overlay .modal-body {
  padding: 20px;
}

.modal-overlay .cropper-container {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-overlay .modal-footer {
  padding: 20px;
  border-top: 1px solid #e5e5e5;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.modal-overlay .rotation-controls {
  display: flex;
  justify-content: center;
  gap: 15px;
}

.modal-overlay .action-controls {
  display: flex;
  justify-content: center;
  gap: 15px;
}

.modal-overlay .btn {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.modal-overlay .btn-icon {
  padding: 12px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-overlay .btn-primary {
  background: #007bff;
  color: white;
}

.modal-overlay .btn-primary:hover {
  background: #0056b3;
  transform: translateY(-1px);
}

.modal-overlay .btn-secondary {
  background: #6c757d;
  color: white;
}

.modal-overlay .btn-secondary:hover {
  background: #545b62;
  transform: translateY(-1px);
}

.modal-overlay .btn-icon.btn-secondary {
  background: #f8f9fa;
  color: #6c757d;
  border: 2px solid #e9ecef;
}

.modal-overlay .btn-icon.btn-secondary:hover {
  background: #e9ecef;
  color: #495057;
  border-color: #dee2e6;
}

.modal-overlay .rotation-icon {
  width: 20px;
  height: 20px;
  fill: currentColor;
}

/* Animation pour les icônes de rotation */
.modal-overlay .btn-icon:hover .rotation-icon {
  transform: rotate(15deg);
  transition: transform 0.2s;
}

.modal-overlay .btn-icon:hover .rotate-left {
  transform: rotate(-15deg);
}



</style>
